<template>
  <div>
    <ReassuranceItem
      class="w-full"
      :has-link="item.clickable"
      @click="item.clickable ? onClick() : undefined"
    >
      <template #icon>
        <DynamicIcon class="md:h-32 md:w-32" :icon="item.icon" size="medium" />
      </template>
      <template #title>
        {{ item.title }}
      </template>
      <template #subtitle>
        {{ item.subtitle }}
      </template>
    </ReassuranceItem>
    <ClientOnly>
      <ItemObsoleteSoftwareModal v-if="item.type === 'software_obsolete'" />
      <ItemObsoleteOSModal v-if="item.type === 'new_os_installed'" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'
import { openModal } from '@ds/components/ModalBase'

import type { GetProductResponse } from '~/api/product-page/types'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import { OBSOLETE_BLOCK_TYPES } from './ItemObsolete.constants'
import ItemObsoleteOSModal from './components/ItemObsoleteOSModal/ItemObsoleteOSModal.vue'
import ItemObsoleteSoftwareModal from './components/ItemObsoleteSoftwareModal/ItemObsoleteSoftwareModal.vue'

const props = defineProps<{
  item: GetProductResponse['reassuranceBlocks'][number]
}>()

function onClick() {
  if (props.item.clickable && OBSOLETE_BLOCK_TYPES[props.item.type]) {
    openModal(OBSOLETE_BLOCK_TYPES[props.item.type])
  }
}
</script>
